export const SegmentedProgressBar = ({
  color,
  current,
  total,
}: {
  color?: string;
  current: number;
  total?: number;
}) => {
  return (
    <div className="segmented-progress-bar">
      {[...Array(total)].map((_, index) => (
        <div
          key={index}
          className={'segment'}
          style={{
            background: `${index < current ? color : '#f2f2f2'}`,
            position: 'relative',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          <div
            className="absolute top-[3px] m-auto h-[3px] bg-white/30 w-[80%]"
            style={{ margin: 'auto' }}
          />
        </div>
      ))}
    </div>
  );
};
